"use client";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { carouselVariants } from "./Carousel.variants.js";
import { CarouselAutoplayButton } from "./CarouselAutoplayButtons.js";
import { CarouselBlurBox } from "./CarouselBlurBox.js";
import { carouselBlurBoxVariants } from "./CarouselBlurBox.variants.js";
import { CarouselDotButton } from "./CarouselDotButton.js";
import { CarouselLightboxButton } from "./CarouselLightboxButton.js";
import { CarouselNextButton, CarouselPrevButton } from "./CarouselPrevNextButtons.js";
import { CarouselSlideNumText } from "./CarouselSlideNumText.js";
function CarouselControls({ config, slides, selectedIndex, prevBtnDisabled, nextBtnDisabled, prevBtnHidden, onPrevButtonClick, onNextButtonClick, onDotButtonClick, onPrevNextButtonClick, onAutoplayButtonClick, onLightboxButtonClick, toggleAutoplay, autoplayIsPlaying, slotClassNames, variantSlots, currentSlide, totalSlides }) {
    const { buttonClass = '', dotsPaginationClass = '', dotButtonClass = '', dotClass = '', blurBoxClass = '', blurBoxDividerClass = '', blurBoxNumbersClass = '', blurBoxLightboxButtonClass = '', blurBoxAutoplayButtonClass = '' } = slotClassNames;
    const prevButtonClasses = cn(variantSlots.prevButtonSlot(), buttonClass);
    const nextButtonClasses = cn(variantSlots.nextButtonSlot(), buttonClass);
    const hiddenButtonClasses = cn(variantSlots.hiddenButtonSlot(), buttonClass);
    const dotsPaginationClasses = cn(variantSlots.dotsPaginationSlot(), dotsPaginationClass);
    const dotButtonClasses = cn(variantSlots.dotButtonSlot(), dotButtonClass);
    const { blurBoxSlot, blurBoxDividerSlot, blurBoxNumbersSlot, blurBoxLightboxButtonSlot, blurBoxAutoplayButtonSlot } = carouselBlurBoxVariants({
        numbers: config.showSlideNum && !config.showLightboxBtn && !config.showAutoplayBtn,
        numbersAndLightbox: config.showSlideNum && config.showLightboxBtn && !config.showAutoplayBtn,
        numbersAndAutoplay: config.showSlideNum && config.showAutoplayBtn && !config.showLightboxBtn,
        numbersAndLightboxAndAutoplay: config.showSlideNum && config.showLightboxBtn && config.showAutoplayBtn
    });
    const blurBoxClasses = cn(blurBoxSlot(), blurBoxClass);
    const blurBoxDividerClasses = cn(blurBoxDividerSlot(), blurBoxDividerClass);
    const blurBoxNumbersClasses = cn(blurBoxNumbersSlot(), blurBoxNumbersClass);
    const blurBoxLightboxButtonClasses = cn(blurBoxLightboxButtonSlot(), blurBoxLightboxButtonClass);
    const blurBoxAutoplayButtonClasses = cn(blurBoxAutoplayButtonSlot(), blurBoxAutoplayButtonClass);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            config.showArrowBtns && /*#__PURE__*/ jsx(CarouselPrevButton, {
                buttonClasses: prevButtonClasses,
                hiddenButtonClasses: hiddenButtonClasses,
                onClick: (event)=>onPrevNextButtonClick(()=>onPrevButtonClick(event)),
                disabled: prevBtnDisabled,
                hidden: prevBtnHidden,
                type: config.isImageCarousel ? 'image' : 'content'
            }),
            config.showArrowBtns && /*#__PURE__*/ jsx(CarouselNextButton, {
                buttonClasses: nextButtonClasses,
                onClick: (event)=>onPrevNextButtonClick(()=>onNextButtonClick(event)),
                disabled: nextBtnDisabled,
                type: config.isImageCarousel ? 'image' : 'content'
            }),
            config.showDotBtns && /*#__PURE__*/ jsx("div", {
                "data-testid": "carousel-dot-buttons",
                className: dotsPaginationClasses,
                children: slides?.map((slide, index)=>{
                    const isSelected = index === selectedIndex;
                    const dotClasses = cn(carouselVariants().dotSlot({
                        isDotSelected: isSelected
                    }), dotClass);
                    const slideId = slide.id;
                    return /*#__PURE__*/ jsx(CarouselDotButton, {
                        index: index,
                        selected: isSelected,
                        onClick: (event)=>config.shouldUseAutoplay ? onAutoplayButtonClick(()=>onDotButtonClick(index, event)) : onDotButtonClick(index, event),
                        dotButtonClasses: dotButtonClasses,
                        dotClasses: dotClasses
                    }, slideId);
                })
            }),
            config.showBlurBox && /*#__PURE__*/ jsxs(CarouselBlurBox, {
                slotClassNames: {
                    blurBoxClasses,
                    blurBoxDividerClasses
                },
                children: [
                    config.showSlideNum && /*#__PURE__*/ jsx(CarouselSlideNumText, {
                        numbersClasses: blurBoxNumbersClasses,
                        "data-id": "carousel-numbers-text",
                        currentSlide: currentSlide,
                        totalSlides: totalSlides
                    }),
                    config.showLightboxBtn && /*#__PURE__*/ jsx(CarouselLightboxButton, {
                        lightboxButtonClasses: blurBoxLightboxButtonClasses,
                        "data-id": "carousel-lightbox-button",
                        onClick: ()=>onLightboxButtonClick(()=>{})
                    }),
                    config.showAutoplayBtn && /*#__PURE__*/ jsx(CarouselAutoplayButton, {
                        autoplayButtonClasses: blurBoxAutoplayButtonClasses,
                        "data-id": "carousel-autoplay-button",
                        onClick: ()=>toggleAutoplay(),
                        autoplayIsPlaying: autoplayIsPlaying
                    })
                ]
            })
        ]
    });
}
export { CarouselControls };
